<template>
    <div></div>
</template>

<script>


export default {
    async mounted () {
        const { token } = this.$route.query;

        try {
            await this.waitForUnifiedPay()
            window.UnifiedPay.mount(null, {
                token: process.env.MIX_UNIFIED_API_TOKEN,
                reauthenticationToken: token,
                onReauthenticated () {
                    this.$router.push('/')
                }
            });

            window.UnifiedPay.open()
        } catch (err) {
            this.$swal({
                type: 'error',
                title: 'Error loading widget',
                text: err.message,
            });
        }
    },
};
</script>
